<template>
  <App>
    <div class="d-flex flex-column flex-xl-row">
      <!--begin::Sidebar-->
      <div class="flex-column flex-lg-row-auto w-450px mb-10">
        <!--begin::Card-->
        <div class="card mb-5 mb-xl-8">
          <!--begin::Card body-->
          <div class="card-body">
            <div id="kt_customer_view_details" class="collapse show">
              <div class="fs-6">
                <div class="fw-bolder mt-5">Observações do(a) Avaliador(a)</div>
                <div class="text-gray-600 mt-5" v-html="avaliacao.avaliacao_projeto.observacoes?.replaceAll('\n', '</br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Sidebar-->
      <!--begin::Content-->
      <div class="flex-lg-row-fluid ms-lg-15">
        <form-body :loading="form.processing" :form="form" hideSubmitButton>
          <div class="mb-10">
            <form-group label="Questão Problema" :is-invalid="form.errors.questao">
              <textarea
                  v-model="form.questao"
                  class="form-control mb-2"
                  type="text"
                  rows="4"
                  placeholder="Questão Problema"
                  @blur="form.clearErrors('questao')"
                  :class="{'is-invalid' : form.errors.questao}"
                  maxlength="250"></textarea>
              <span class="text-muted">{{caracteresRestantes(250, 'questao')}}</span>
            </form-group>
          </div>

          <div class="mb-10">
            <form-group label="Introdução" :is-invalid="form.errors.introducao">
              <textarea
              v-model="form.introducao"
              class="form-control mb-2"
              type="text"
              rows="15"
              placeholder="Introdução"
              @blur="form.clearErrors('introducao')"
              :class="{'is-invalid' : form.errors.introducao}"
              maxlength="1800"></textarea>
              <span class="text-muted">{{caracteresRestantes(1800, 'introducao')}}</span>
            </form-group>
          </div>

          <div class="mb-10">
            <form-group label="Abordagem teórica" :is-invalid="form.errors.abordagem">
              <textarea
                  v-model="form.abordagem"
                  class="form-control mb-2"
                  type="text"
                  rows="13"
                  placeholder="Abordagem teórica"
                  @blur="form.clearErrors('abordagem')"
                  :class="{'is-invalid' : form.errors.abordagem}"
                  maxlength="1200"></textarea>
              <span class="text-muted">{{caracteresRestantes(1200, 'abordagem')}}</span>
            </form-group>
          </div>

          <div class="mb-10">
            <form-group label="Referências Bibliográficas" :is-invalid="form.errors.referencia">
              <textarea
                  v-model="form.referencia"
                  class="form-control mb-2"
                  type="text"
                  rows="8"
                  placeholder="Referências Bibliográficas"
                  @blur="form.clearErrors('referencia')"
                  :class="{'is-invalid' : form.errors.referencia}"
                  maxlength="600"></textarea>
              <span class="text-muted">{{caracteresRestantes(600, 'referencia')}}</span>
            </form-group>
          </div>

          <button @click="enviarCorrecao" v-if="avaliacao.situacao === 1" class="btn btn-success mt-3">
            Enviar
          </button>
        </form-body>
      </div>
    </div>
  </App>
</template>
<script>
import App from "@layout/App";
import {Link, useForm} from "@inertiajs/inertia-vue3";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import axios from "axios";

export default {
  props: ['avaliacao'],

  components: {
    FormGroup,
    FormBody,
    Datepicker,
    SubmitButton,
    App,
    Link,
  },

  setup(props) {
    const form = useForm({
      id: props.avaliacao.projeto.id,
      introducao: props.avaliacao.projeto.introducao,
      abordagem: props.avaliacao.projeto.abordagem,
      referencia: props.avaliacao.projeto.referencia,
      questao: props.avaliacao.projeto.questao
    })
    return {form};
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.emitter.emit('title', 'Corrige Projeto');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Projetos', link: 'app.projetos.index'},
        {title: 'Corrige Projeto'},
      ]);

      this.emitter.emit('action', {
            show: true,
            icon: 'bi-arrow-left-short',
            title: 'Voltar',
            link: this.route('app.projetos.index')
          }
      );
    },

    enviarCorrecao() {
      this.emitter.emit('alert', {
        title: 'Confirma a ação?',
        text: 'Tem certeza que deseja enviar suas correções?',
        icon: 'warning',
        success: this.envia
      })
    },

    envia() {
      this.form.processing = true
      this.form.post(this.route('app.projetos.corrige-projeto-update', {'id': this.form.id}))
    },

    caracteresRestantes(limit, input) {
      var char = this.form[input]?.length;
      let count = char ? (limit - char) : limit
      return count + " caracteres restantes de " + limit;
    }
  },
};
</script>
